import React, { useState } from 'react';
import './App.css';
import Card from './Card.js';

import { Range, Lab } from 'react-range';

import LabeledTwoThumbs from './LabeledTwoThumbs'

function App() {
  const dataString = require('./data.json');
  const data = dataString.elements;

  const [value, setValue] = useState([0, 100])

  const generateElements = () => {
    var elements = [];

    for (var i = value[0]; i < value[1]; i++) {
      elements.push(<Card index={i + 1} item={data[i]} />);
    }

    return elements;
  }

  return (
    <div className="App">
      <div>
        <p class="logo_text"><span class="boost_text">Boost</span><span class="lango_text">lango</span></p>
        <p class="text_1">Darmowa aplikacja mobilna do nauki 3000 najczęściej używanych słów w języku angielskim.</p>
        <p class="text_1">W aplikacji możesz powtarzać słowa oraz usłyszeć wymowę.</p>
        <p class="text_1">Każde przykładowe zdanie zbudowane jest tylko ze słów, które już znasz.</p>
        <p class="text_1">Aplikacja dostępna na Android.</p>
        <a href='https://play.google.com/store/apps/details?id=com.boostlango&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
          <img width="200px" class="img_play" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
        </a>
        <p class="text_2">Poniżej możesz sprawdzić czy znasz 3000 najczęściej używanych słów.</p>
        <p class="text_2">Wybieraj małe zakresy i sprawdzaj swoją wiedzę.</p>
      </div>
      <div class="labeled-thumbs">
        <LabeledTwoThumbs onChange={(arr) => setValue(arr)} />
        <br/><br/>
      </div>
      <div class="flex-container">
        {generateElements()}
      </div>
    </div>
  );
}

export default App;
